"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const searchParamState_1 = __importDefault(require("./searchParamState"));
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
function default_1() {
    const keywordSearchParam = (0, functions_1.getSearchParam)('keyword');
    const [keyword, setKeyword] = (0, react_1.useState)(keywordSearchParam !== null && keywordSearchParam !== void 0 ? keywordSearchParam : '');
    const [{ searchFond }, setSearchParams] = (0, recoil_1.useRecoilState)(searchParamState_1.default);
    (0, react_1.useEffect)(() => {
        if (searchFond)
            setKeyword('');
    }, [searchFond]);
    const onSearchEnter = () => {
        if (keyword) {
            if (window.location.pathname === '/room/search') {
                (0, functions_1.replaceSearchParam)({ prefix: 'search', paramArr: [{ key: 'keyword', val: keyword }] });
                setSearchParams({ searchKeyword: keyword, searchFond: undefined });
            }
            else {
                window.location.href = `/room/search?keyword=${keyword}`;
            }
        }
    };
    const onSearchCancel = () => {
        setKeyword('');
    };
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-table-row", css: {
            display: 'flex',
            alignItems: 'center',
            columnGap: '10px',
            width: '100%',
            maxWidth: maxWidth768 ? 'none' : '300px',
            height: maxWidth768 ? '40px' : '32px',
            padding: '0 14px',
            borderRadius: '8px',
        } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.SearchIconSvg, { css: { flexShrink: 0, width: '18px', height: '18px', cursor: 'pointer' }, onClick: onSearchEnter }), (0, jsx_runtime_1.jsx)("input", { value: keyword, onChange: e => setKeyword(e.target.value.slice(0, 40)), onKeyDown: e => {
                    e.key === 'Enter' && onSearchEnter();
                    e.key === 'Escape' && onSearchCancel();
                }, placeholder: t('제목, 작품명, 태그 검색'), className: "body2 gray-80 surface-table-row", css: {
                    width: '100%',
                    '::placeholder': { color: 'var(--gray-60)' },
                } })] })));
}
exports.default = default_1;
